import { ListItemIcon, ListItemText, MenuItem, Typography } from '@material-ui/core';
import { createElement, FC, Fragment, MouseEventHandler, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

interface Props {
  startIcon: ReactNode;
  onClick: MouseEventHandler<HTMLElement>;
  labelMessageId: string;
  endIcon?: ReactNode;
}

const UserPopupMenuItem: FC<Props> = ({ startIcon, onClick, labelMessageId, endIcon = <Fragment /> }) => {
  return (
    <MenuItem button onClick={onClick}>
      <ListItemIcon>{startIcon}</ListItemIcon>
      <ListItemText
        primary={
          <Typography>
            <FormattedMessage id={labelMessageId} />
          </Typography>
        }
      />
      {endIcon}
    </MenuItem>
  );
};

export default UserPopupMenuItem;
